import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const footerImage = 'https://customer-assets.emergentagent.com/job_aussie-grain/artifacts/iim30iju_3kn0z5ve_Truck%20unloading.jpeg';

const quickLinks = [
  { name: 'About Us', href: '/about' },
  { name: 'Our Business', href: '/business' },
  { name: 'Harvest 2025/26', href: '/harvest' },
  { name: 'Sponsorship', href: '/sponsorship' },
  { name: 'Gallery', href: '/gallery' },
  { name: 'Grain Portal', href: '/portal' }
];

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Image & Tagline */}
          <div>
            <div className="w-full h-44 rounded-lg overflow-hidden mb-4">
              <img
                src={footerImage}
                alt="Grain handling facility"
                className="w-full h-full object-cover"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Trusted grain storage and container packing solutions in the heart of Victoria.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-yellow-500 font-bold text-lg mb-6">
              Quick Links
            </h3>
            <nav className="flex flex-col space-y-3">
              {quickLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="text-yellow-500 font-bold text-lg mb-6">
              Contact Us
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-gray-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-400 text-sm">35 Milburns Road</p>
                  <p className="text-gray-400 text-sm">Wycheproof VIC 3527</p>
                  <p className="text-gray-400 text-sm">Australia</p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-gray-500 flex-shrink-0" />
                <a
                  href="tel:+61354937444"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  +61 3 5493 7444
                </a>
              </div>

              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-gray-500 flex-shrink-0" />
                <a
                  href="mailto:wyche-admin@wychegrain.com.au"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  wyche-admin@wychegrain.com.au
                </a>
              </div>

              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-gray-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-400 text-sm">8am - 4:30pm</p>
                  <p className="text-gray-400 text-sm">Monday to Friday</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <p className="text-center text-gray-500 text-sm">
            © 2026 Wycheproof Grain Handling Pty Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
